"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverlayTransition = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

var _times = require("HubStyleTokens/times");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  .private-modal-dialog--overlay {\n    transition-property: ", ";\n    transition-delay: ", "ms;\n    transition-duration: ", ";\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getOverlayTransition = function getOverlayTransition(dialogTransitionTime) {
  return (0, _styledComponents.css)(_templateObject(), function (_ref) {
    var transitioning = _ref.transitioning;
    return transitioning ? 'background-color' : 'none';
  }, function (_ref2) {
    var open = _ref2.open;
    return open ? 0 : dialogTransitionTime;
  }, _times.MODAL_BACKGROUND_TRANSITION_TIMING, function (_ref3) {
    var open = _ref3.open;
    return "rgba(45, 62, 80, " + (open ? '0.79' : '0') + ")";
  });
};

exports.getOverlayTransition = getOverlayTransition;